module.exports = __webpack_public_path__ + "img/数据分析系统-图片.b706c7d7.png";